import { MEASUREMENT_SYSTEM_METRIC, MEASUREMENT_SYSTEM_IMPERIAL, DIFFERENTIAL_PRESSURE_UNIT_PASCAL, DIFFERENTIAL_PRESSURE_UNIT_INCHES_OF_WATER } from 'services/UserPreferencesManager';

/* @ngInject */
export default class PopoverController {
    constructor(AuthService, UserPreferencesManager, $rootScope) {
        this.AuthService = AuthService;
        this.UserPreferencesManager = UserPreferencesManager;
        this.$rootScope = $rootScope;
    }

    $onInit() {
        const authData = this.AuthService.getAuthData();

        if (authData) {
            this.userProfile = authData.profile;
        }

        // Use the locally cached measurement system
        this.measurementSystem = this.UserPreferencesManager.getMeasurementSystem();
        this.metricValue = MEASUREMENT_SYSTEM_METRIC;
        this.imperialValue = MEASUREMENT_SYSTEM_IMPERIAL
        this.differentialPressureUnit = this.UserPreferencesManager.getDifferentialPressureUnit();
        this.pascalValue = DIFFERENTIAL_PRESSURE_UNIT_PASCAL;
        this.inchesOfWaterValue = DIFFERENTIAL_PRESSURE_UNIT_INCHES_OF_WATER;

        // Refresh the local cache, and update if it changed
        this.UserPreferencesManager.refresh()
            .then(() => {
                this.measurementSystem = this.UserPreferencesManager.getMeasurementSystem();
                this.differentialPressureUnit = this.UserPreferencesManager.getDifferentialPressureUnit();
            })
    }

    onMeasurementSystemChange() {
        this.UserPreferencesManager.setMeasurementSystem(this.measurementSystem)
    }

    onDifferentialPressureUnitChange() {
        this.UserPreferencesManager.setDifferentialPressureUnit(this.differentialPressureUnit)
    }

    signOut() {
        this.AuthService.signOut();
    }
}


